export default {
    namespaced: true,
    state: {
        trxComercio: null,
        trxComercioBloquear: false,
        trxComercioPagada: null,
        configuracionComercio: null
    },
    mutations: {
        actualizarTrxComercio(state, trxComercio) {
            state.trxComercio = trxComercio;
        },
        trxComercioPagadaNull(state){
            state.trxComercioPagada = null
        },
        trxComercioPagadaFalse(state){
            state.trxComercioPagada = false
        },
        trxComercioPagadaTrue(state){
            state.trxComercioPagada = true
        },
        trxComercioBloquearTrue(state) {
            state.trxComercioBloquear = true;
        },
        trxComercioBloquearFalse(state) {
            state.trxComercioBloquear = false;
        },
        actualizacionConfiguracionComercio(state, payload) {
            state.configuracionComercio = payload;
        },
    },
    actions: {
        actualizarTrxComercio({
            commit
        }, payload) {
            commit("actualizarTrxComercio", payload.trxComercio);
        },
        actualizarConfiguracionComercio({
            commit
        }, payload) {
            commit("actualizacionConfiguracionComercio", payload);
        },
        resetearTrxComercio({
            commit
        }) {
            commit("actualizarTrxComercio", null);
            commit("trxComercioPagadaNull");
            commit("trxComercioBloquearFalse");
            commit("actualizacionConfiguracionComercio", null);
        }
    }
}
